import Vue from 'vue';
import deepFreeze from 'deep-freeze-es6'
import VueI18n from 'vue-i18n';
import Vuelidate from 'vuelidate';
import PortalVue from 'portal-vue'
import vSelect from 'vue-select';
import gtm from './vendors/gtm'
import store from './store/index';
import App from './components/App';
import configureAxios from './utils/axiosConfig';

gtm()

document.addEventListener('DOMContentLoaded', () => {
  const isIE = window.navigator.msPointerEnabled;
  if (isIE === true) document.querySelector('body').classList.add('ie');
});

// Libs
Vue.use(VueI18n);
Vue.use(Vuelidate);
Vue.use(PortalVue);
Vue.component('v-select', vSelect)
configureAxios();
// Hydrate store
store.replaceState({ ...store.state, ...deepFreeze(window.renaultRent) });

const i18n = new VueI18n({
  locale: 'fr', // Single language website atm
  messages: window.renaultRent.i18n,
  numberFormats: {
    'fr-FR': {
      currency: {
        style: 'currency', currency: 'EUR',
      },
    },
  },
});

window.VueApp = new Vue({
  el: '.app',
  components: {
    App,
  },
  store,
  i18n,
});
